import { getSVGIcon } from "../utilities/globalUtilities";
import { getAllCachedCoupons, getCachedCouponsSelected, removeDuplicates, getIsAllSelected } from "../cart/components/CouponsCarouselComponentJQuery";
import { COUPONS_LIMIT } from "../utilities/constants";

/**
 * Build the coupon card structure
 * @param {String} loyaltyCouponCode - Loyalty coupon code
 * @param {String} appliedResource - Applied coupon resource
 * @param {String} notAppliedResource - not applied coupon resource
 */
const buildLoyaltyCouponCard = (loyaltyCouponCode, appliedResource, notAppliedResource) => {
    if (!loyaltyCouponCode) { return ""; }

    let couponCardHTML = "";
    let couponDescriptionHTML = "";
    const isInCarousel = $(`#coupon-${loyaltyCouponCode.id}`).length;
    const cssClass = isInCarousel ? "d-none" : "";
    const spanClass = loyaltyCouponCode.applied ? "coupon-applied" :  "coupon-not-applied";
    const resourceToUse = loyaltyCouponCode.applied ? appliedResource : notAppliedResource;

    if (loyaltyCouponCode.description != null) {
        couponDescriptionHTML = `<p class="applied-coupon-description">${loyaltyCouponCode.description}</p>`;
    }

    couponCardHTML =
    `
        <div class="js-loyalty-coupon-area w-100 mt-2 ct-cart--applied-coupon-card coupon-price-adjustment coupon-uuid-${loyaltyCouponCode.id} ${cssClass}" data-uuid="${loyaltyCouponCode.id}">
            <div class="loyalty-coupon-code">
                <span>${loyaltyCouponCode.id}</span>
                <span class="${spanClass}">${resourceToUse}</span>

                <button type="button" class="float-right remove-coupon pr-1"
                        data-toggle="modal"
                        data-code="${loyaltyCouponCode.id}"
                        data-uuid="${loyaltyCouponCode.id}">
                    ${getSVGIcon("icon-trash")}
                </button>
            </div>
            ${couponDescriptionHTML}
        </div>
    `;

    return couponCardHTML;
};

/**
 * Builds the HTML for the list of loyalty applied coupons
 * @param {Array} loyaltyCouponCodeArray
 */
const buildLoyaltyCouponCardList = loyaltyCouponCodeArray => {
    if (!loyaltyCouponCodeArray) { return null; }

    const appliedResource = $(".coupons-and-promos").data("applied");
    const notAppliedResource = $(".coupons-and-promos").data("not-applied");
    let loyaltyCouponsHTML = "";

    loyaltyCouponCodeArray.forEach((element) => {
        loyaltyCouponsHTML += buildLoyaltyCouponCard(element, appliedResource, notAppliedResource);
    });

    return loyaltyCouponsHTML;
};

/**
 * Verifies and check the coupons already applied to the basket
 * @param {Array} appliedCoupons
 */
const verifyAndCheckAppliedCarouselCoupons = appliedCoupons => {
    if (!appliedCoupons) { return; }
    if (typeof appliedCoupons == "string") {
        appliedCoupons = JSON.parse(appliedCoupons);
    }

    $(".coupon-carousel-input").prop("checked", false);

    appliedCoupons.forEach(element => {
        $(`[name="coupon-${element.id}"]`).prop("checked", true);
    });

    updateSelectAllCouponsInput();
};

/**
 * Init carousel selection items
 */
const initCarouselSelectionItems = () => {
    const appliedCouponsString = $(".js-loyalty-coupons").attr("data-applied-coupons");

    if (!appliedCouponsString) { return; }

    const appliedCoupons = appliedCouponsString.split(",");

    document.querySelectorAll(".coupon-carousel-input").forEach((idx, item) => {
        if (appliedCoupons.includes(item.value)) { item.checked = true; }
    });
};

/**
 * Check if all the coupons from the carousel are applied and update the input' state
 */
const updateSelectAllCouponsInput = () => {
    const $selectAllCouponTilesInput = $(".select-all-coupon-tiles");
    const allCouponsFromCarouselSelected = $(".slick-slide:not(.slick-cloned) .coupon-carousel-input:checked").length;
    const allCouponsFromCarouselUsed = $(".slick-slide:not(.slick-cloned) .coupon-carousel-input").length === $(".slick-slide:not(.slick-cloned) .coupon-carousel-input:checked").length;
    const couponsLoaded = getAllCachedCoupons();
    // not only from the current brand, but from every brand
    const getSelectedCoupons = getCachedCouponsSelected();
    let auxArray = removeDuplicates(getSelectedCoupons);
    if (allCouponsFromCarouselSelected == COUPONS_LIMIT || getIsAllSelected() == true) {
        $selectAllCouponTilesInput.prop("checked", true);
    } else if (allCouponsFromCarouselSelected == couponsLoaded.length) {
        // if total amount of coupons selected == inital number of coupons loaded
        $selectAllCouponTilesInput.prop("checked", true);
    } else if (auxArray.length == couponsLoaded.length) {
        $selectAllCouponTilesInput.prop("checked", true);
    } else {
        $selectAllCouponTilesInput.prop("checked", allCouponsFromCarouselUsed);
    }
};

export {
    buildLoyaltyCouponCard,
    buildLoyaltyCouponCardList,
    verifyAndCheckAppliedCarouselCoupons,
    initCarouselSelectionItems,
    updateSelectAllCouponsInput
};
